import { render } from "./Exhibitions.vue?vue&type=template&id=842711b4&scoped=true"
import script from "./Exhibitions.vue?vue&type=script&lang=js"
export * from "./Exhibitions.vue?vue&type=script&lang=js"

import "./Exhibitions.vue?vue&type=style&index=0&id=842711b4&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-842711b4"]])

export default __exports__